import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "updateMode"]

  connect() {
    this.confirmed = false
  }

  intercept(event) {
    if (this.confirmed) return

    event.preventDefault()
    this.modalTarget.showModal()
  }

  override() {
    this.updateModeTarget.value = "override"
    this.confirmed = true
    this.modalTarget.close()
    this.element.requestSubmit()
  }

  discontinueAndCreate() {
    this.updateModeTarget.value = "discontinue_and_create"
    this.confirmed = true
    this.modalTarget.close()
    this.element.requestSubmit()
  }
}
